import React from "react";
import { Card, CardContent, Grid } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import "./Cartoon.css"; 

// // Ghibili Image
// import GhibiliImage from "../../assets/ghibili1.jpg";
// import GhibiliImage2 from "../../assets/ghibili2.jpg";
// import GhibiliImage3 from "../../assets/ghibili3.jpg";

const ideas = [
  {
    title: "Cartoon Date Ideas",
    description: "Explore fun and quirky cartoon-themed date ideas full of charm!",
    images: ['GhibiliImage'], 
    type: "cartoon",
  },
  {
    title: "Cartoon Dinner Time",
    description: "Spice up your meals with cartoon-style dinner inspiration!",
    images: ['GhibiliImage2'], 
    type: "cartoon",
  },
  {
    title: "Cartoon Gift Picks",
    description: "Find the perfect cartoon gift ideas that spark joy!",
    images: ['GhibiliImage3'], 
    type: "cartoon",
  },
];

const CartoonCards = () => {
  const navigate = useNavigate();
  return (
    <Grid item xs={12} className=" height-content">
      <Grid container spacing={2} className="cartoon-model">
        {ideas.map((idea, index) => (
          <Grid item xs={12} sm={12 / 3} md={12 / 3} lg={12 / 3} key={index} style={{ cursor: "pointer" , padding: '20px 30px'}}>
            <Card className="idea-card"
            onClick={(e: any) => { navigate("/cartoon/dashboard") }}
            >
              <div className="left-images">
                {idea.images.slice(0, 2).map((img, i) => (
                  <img
                    key={i}
                    className="stacked-images"
                    src={img}
                    alt={`stacked-image`}
                    style={{ objectFit: "cover" }}
                  />
                ))}
              </div>
            </Card>
            <CardContent className="card-content">
              <h3 className="card-title">{idea.title}</h3>
              <p className="card-description">{idea.description}</p>
              <div onClick={(e: any) => { navigate("/cartoon/dashboard"); }} className="arrow-icon">
                <ArrowForwardIcon />
              </div>
            </CardContent>
          </Grid>
        ))}
      </Grid>

    </Grid>
  );
};

export default CartoonCards;
